import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  ModalBody,
  Card,
  CardBody,
  CardHeader,
  CustomInput,
  Modal,
  ModalHeader,
  ModalFooter
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor'
import DateTime from 'react-datetime';
import ReactSelect from '../../../components/Form/Select/Select';
import AsyncSelect from 'react-select/async';
import './style.css';

import rotas from 'services/rotas';
import rest from 'lib/rest';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import Loading from 'lib/loading';
import settings from 'settings';
import Axios from 'axios';
import moment from 'moment';
import useForm from 'lib/useForm';
import { homepage } from '../../../../package.json';
import Iframe from 'react-iframe';

const formSwal = withReactContent(Swal)

const FormCadastroTabloide = ({ closeModal, tabloide_id, recarregaLista }) => {

  const initialForm = {
    tabloid_id: 0,
    ativo: "N",
    data_cadastro: "",
    estado: "",
    inicio_promocao: "",
    tabloid: "",
    termino_promocao: "",
  }

  const initialLojas = [
    {
      filial_id: 0,
      razao_social: '',
      checked: false
    }
  ]

  const estados = [
    { id: 'AC', title: 'AC' },
    { id: 'AL', title: 'AL' },
    { id: 'AM', title: 'AM' },
    { id: 'AP', title: 'AP' },
    { id: 'BA', title: 'BA' },
    { id: 'CE', title: 'CE' },
    { id: 'DF', title: 'DF' },
    { id: 'ES', title: 'ES' },
    { id: 'GO', title: 'GO' },
    { id: 'MA', title: 'MA' },
    { id: 'MG', title: 'MG' },
    { id: 'MS', title: 'MS' },
    { id: 'MT', title: 'MT' },
    { id: 'PA', title: 'PA' },
    { id: 'PB', title: 'PB' },
    { id: 'PE', title: 'PE' },
    { id: 'PI', title: 'PI' },
    { id: 'PR', title: 'PR' },
    { id: 'RJ', title: 'RJ' },
    { id: 'RN', title: 'RN' },
    { id: 'RO', title: 'RO' },
    { id: 'RR', title: 'RR' },
    { id: 'RS', title: 'RS' },
    { id: 'SC', title: 'SC' },
    { id: 'SE', title: 'SE' },
    { id: 'SP', title: 'SP' },
    { id: 'TO', title: 'TO' }
  ]

  const [activeTab, setActiveTab] = useState('1');
  const [checkAll, setCheckAll] = useState(false);
  const [data, setData] = useState([]);
  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(initialForm);
  const [loading, setLoading] = useState(true);
  const [loadingProd, setLoadingProd] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [lojas, setLojas] = useState([]);
  const [valorPromocional, setValorPromocional] = useState(0);
  const [produtoTabloide, setProdutoTabloide] = useState([]);
  const [listaProdutosTabloide, setListaProdutosTabloide] = useState([]);
  const [idMatriz, setIdMatriz] = useState('');
  const [idCadastrado, setIdCadastrado] = useState(0);
  const [modalPlanilha, setModalPlanilha] = useState(false);

  const inputRef = useRef(null);

  const columns = [{
    dataField: 'produto_id',
    text: 'id',
    hidden: true
  }, {
    dataField: 'cod_barras',
    text: 'CODIGO BARRAS'
  }, {
    dataField: 'produto',
    text: 'PRODUTO',
    editable: false,
  }, {
    dataField: 'preco_tabloid',
    text: 'Preço Tablóide',
    editable: true,
  }, {
    dataField: 'excluir',
    text: 'Excluir',
    editable: false,
    formatter: (cellContent, row) => {
      return (
        <Button
          id=""
          className="btn-icon btn-neutral"
          color="danger"
          size="md"
          type="button"
          onClick={() => deleteProdutoTabloide(row)}
        >
          <i className="fas fa-times" />
        </Button>
      )
    }
  }];

  const toggleTab = (tab) => {

    if (idCadastrado === 0) {
      Swal.fire({
        title: 'Deseja Gravar o tablóide?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        denyButtonText: 'Não',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          gravaTabloide();
          if (activeTab !== tab) {
            setActiveTab(tab);
          }
        }
      })
    } else {
      if (activeTab !== tab) {
        setActiveTab(tab);
      }
    }

  }

  useEffect(() => {
    listarTabloide();
    listaLojasTabloide();
    listarProdutosTabloide();

    // if(tabloide_id>0){
    //   listaLojasTabloide();
    // }

    setLoading(false);
  }, [])

  const listarTabloide = () => {
    if (tabloide_id > 0) {
      setIdCadastrado(tabloide_id);

      const url = settings.url + rotas.listarTabloides;
      const retorno = rest.get(url + '?tabloide_id=' + tabloide_id);

      retorno.then(ret => {
        if (ret.retorno.length > 0) {
          setForm(ret.retorno[0]);
        }
        setLoading(false);
      })
    }
  }

  const listaLojasTabloide = () => {
    const url = settings.url + rotas.lojasTabloide;
    const retorno = rest.get(url + '?tabloid_id=' + tabloide_id);

    retorno.then(ret => {
      let oLoja = {};
      let ljs = [];

      ret.retorno.todas_lojas.map(lj => {
        oLoja = {
          filial_id: lj.filial_id,
          fantasia: lj.fantasia,
          checked: false
        }

        ljs.push(oLoja);

        if (lj.is_central === 'S') {
          setIdMatriz(lj.filial_id);
        }
      })

      for (let x = 0; x < ljs.length; x++) {
        for (let y = 0; y < ret.retorno.lojas_participantes.length; y++) {
          if (ljs[x].filial_id === ret.retorno.lojas_participantes[y].filial_id) {
            if (ret.retorno.lojas_participantes[y].filial_id_participante !== '0') {
              ljs[x].checked = true;
            }
          }
        }
      }

      setLojas(ljs);
      setLoading(false);
    })
  }

  //componente datatime, campo vazio
  const focousOutInicio = (value) => {
    if (!moment(value).isValid()) {
      form.inicio_promocao = '';
    }
  }
  const focousOutTermino = (value) => {
    if (!moment(value).isValid()) {
      form.termino_promocao = '';
    }
  }

  const gravaTabloide = () => {

    if (form.tabloid === '') {
      Swal.fire('Atenção',
        'Digite um nome para o tablóide!',
        'warning');
      return;
    }

    if (form.inicio_promocao === '') {
      Swal.fire('Atenção',
        'Digite a data de inicio do tablóide!',
        'warning');
      return;
    }

    if (form.termino_promocao === '') {
      Swal.fire('Atenção',
        'Digite a data de término do tablóide!',
        'warning');
      return;
    }

    if (form.estado === '') {
      Swal.fire('Atenção',
        'Digite o estado para onde o tablóide será válido!',
        'warning');
      return;
    }

    let frm = form;
    let parametros = {};
    parametros.lojas = lojas;
    parametros.tabloide = frm;


    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text: 'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {

        const url = rotas.tabloideCadastro + 'gravar.php'

        if (idCadastrado > 0) {
          parametros.tabloide.tabloid_id = idCadastrado;
          return rest.post(url, parametros)
            .then(ret => {
              if (ret.success == 'S') {
                setIdCadastrado(idCadastrado);
                formSwal.fire('Registro gravado com sucesso!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })

        } else {
          return rest.put(url, parametros)
            .then(ret => {
              if (ret.success == 'S') {
                setIdCadastrado(ret.tabloid_id);
                formSwal.fire('Registro gravado com sucesso!', ret.msg, 'success')
              } else {
                formSwal.fire('Erro!', ret.msg, 'error')
              }
            })
        }
      }
    }])
  }

  const changeDataI = (dados) => {
    console.log(dados)

    let tbld = form;

    if (dados.length === 2) {
      tbld.inicio_promocao = dados + '/';

    } else if (dados.length === 5) {
      tbld.inicio_promocao = dados + '/';

    } else {
      tbld.inicio_promocao = dados;
    }

    if (tbld.inicio_promocao.length > 10) {
      tbld.inicio_promocao = tbld.inicio_promocao.substring(0, 10)
    }

    if (typeof (dados) === 'object') {
      tbld.inicio_promocao = moment(tbld.inicio_promocao.length).format('DD/MM/YYYY');
    }

    setForm(tbld);
    setRefresh(refresh + 1)
  }

  const changeDataF = (dados) => {
    let tbld = form;

    if (dados.length === 2) {
      tbld.termino_promocao = dados + '/';

    } else if (dados.length === 5) {
      tbld.termino_promocao = dados + '/';

    } else {
      tbld.termino_promocao = dados;
    }

    if (tbld.termino_promocao.length > 10) {
      tbld.termino_promocao = tbld.termino_promocao.substring(0, 10)
    }

    setForm(tbld);
    setRefresh(refresh + 1)
  }

  const blurEstado = (evt) => {
    const estado = evt.title;

    let tbld = form
    tbld.estado = estado;
    setForm(tbld);
    setRefresh(refresh + 1);

  }

  const blurTabloide = (evt) => {
    const nomeTabloide = evt.target.value.toUpperCase();

    let tbld = form
    tbld.tabloid = nomeTabloide;
    setForm(tbld);
    setRefresh(refresh + 1)
  }

  const inputToUpper = (evt) => {
    evt.target.value = evt.target.value.toUpperCase();
  }

  const checkLoja = (evt) => {
    let ljs = lojas;

    ljs.map(lj => {
      if (lj.filial_id === evt.target.id) {
        lj.checked = evt.target.checked;
      }
    })

    setLojas(ljs);
    setRefresh(refresh + 1);
  }

  const setAtivo = (evt) => {
    let tbld = form;

    if (evt.target.checked) {
      tbld.ativo = 'S';
    } else {
      tbld.ativo = 'N';
    }
    setForm(tbld);
    setRefresh(refresh + 1);
  }

  const pesquisaProdutos = (value) => {

    if (value.length > 2) {
      const pesquisa = value;
      const parametros = {
        todos: 'N',
        filial_id: idMatriz,
        produto: pesquisa
      }
      const url = settings.url + rotas.produtos;
      const retorno = rest.post(url, parametros);

      return retorno.then(ret => {
        let lista = [];
        ret.produtos.map(prod => {
          lista.push({
            label: prod.produto,
            value: prod.produto_id,
            cod_barras: prod.cod_barras
          })
        })
        return (lista)
      })
    }

    // if(type === 'pagination'){
    //   const parametros = {
    //     todos: 'S',
    //     paginacao: {pagina:filtros.page}
    //   }
    //   const url = settings.url + rotas.produtos;
    //   const retorno = rest.post(url, parametros);

    //   retorno.then(ret => {
    //     //console.log(ret.data);
    //     setdata(ret.produtos)
    //   }) 
    // }
  }

  const produtoSelecionado = (oProduto) => {
    if (oProduto.cod_barras !== '') {
      setProdutoTabloide({ produto_id: oProduto.value, cod_barras: oProduto.cod_barras });
    } else {
      Swal.fire('Atenção',
        'Produto sem código de barras!',
        'warning');
    }
  }

  const changeValorPromocional = (evt) => {
    setValorPromocional(evt.target.value);
  }

  const listarProdutosTabloide = () => {
    setLoadingProd(true);
    
    const url = settings.url + rotas.produtosTabloide;

    let retorno = rest.get(url + '?tabloid_id=' + (tabloide_id > 0 ? tabloide_id : idCadastrado));
    retorno.then(ret => {
      setLoadingProd(false);
      if (ret.success && ret.success == 'S') {
        setListaProdutosTabloide(ret.retorno);
      } else {
        setListaProdutosTabloide([]);
      }
    })
  }

  const adicionaProdutoTabloide = () => {

    if (valorPromocional == 0) {
      Swal.fire(
        'Atenção',
        'Informe um valor para o produto!',
        'warning'
      )
    }

    if ((valorPromocional > 0) &&
      (produtoTabloide.produto_id > 0) &&
      (produtoTabloide.cod_barras !== '')) {

      const url = settings.url + rotas.produtosTabloide;

      const parametros = {
        produto_id: produtoTabloide.produto_id,
        preco_tabloid: valorPromocional,
        tabloid_id: tabloide_id > 0 ? tabloide_id : idCadastrado
      }

      let retorno = rest.post(url, parametros);
      retorno.then(ret => {
        if (ret.success === 'S') {
          setValorPromocional(0);
          listarProdutosTabloide();
        } else {
          if (ret.msg === 'Registro Duplicado') {
            Swal.fire(
              'Erro',
              'Produto já cadastrado!',
              'error'
            )
          } else {
            Swal.fire(
              'Erro',
              'Erro gravando produto!',
              'error'
            )
          }
        }
      })
    }
  }

  const fecharModal = () => {
    //recarregaLista();
    closeModal();
  }

  const carregaXLS = (evt) => {
    // const fileReader = new FileReader();
    // fileReader.onloadend = e => {
    //   const content = fileReader.result;
    //   console.log(fileReader);
    //   // readXlsxFile(fs.createReadStream(content)).then((rows) => {
    //   // console.log(rows) 
    // // })
    // };

    // fileReader.readAsBinaryString(evt.target.files[0])

    //const workSheetsFromFile = xlsx.parse(evt.target.files[0]);


    //console.log(workSheetsFromFile);

    // evt.preventDefault();
    // const url = URL.createObjectURL(evt.target.files[0]);
    // console.log(url)
    // let img = {};

    // Swal.fire({
    //   title: "Aguarde",
    //   // html: "I will close in <b></b> milliseconds.",
    //   // timer: 2000,
    //   timerProgressBar: true,
    //   didOpen: () => {
    //     Swal.showLoading();
    //     // const timer = Swal.getPopup().querySelector("b");
    //     // timerInterval = setInterval(() => {
    //     //   timer.textContent = `${Swal.getTimerLeft()}`;
    //     // }, 100);
    //   }
    // })

    const tgtFile = evt.target.files[0];

    Swal.fire({
        title:'Confirmação',
        text:'Confirma o envio do arquivo?',
        icon:'question',
        confirmButtonText: "Sim",
        showCancelButton:true,      
      }).then(resp=>{
      if(resp.isConfirmed == true){

        setLoadingProd(true);

        const url = settings.url + rotas.uploadTabloide;
        
        let form = new FormData();
    
        const token = sessionStorage.getItem('token')
    
        form.append('fileUpload', tgtFile);
        form.append('authentication', token);
        form.append('tabloid_id', tabloide_id);
    
        //Axios.post(url, form, {token: token, dados:form},{ 
    
        Axios.post(url, form, {
          headers: {
            "Content-Type": `multipart/form-data; boundary=${form._boundary}`,
          }
        }).then(response => {
          setLoadingProd(false);
          if (response.data.success === 'S') {
            if(response.data.todos_produtos == 'N'){
              Swal.fire('Atenção','Nem Todos os Produtos Foram Inseridos, Verifique!','warning');
            }else{
              Swal.fire('Sucesso','Produtos Gravados com Sucesso!','success');
            }
            listarProdutosTabloide();
          } else {
            Swal.fire('Erro', 'Erro processando arquivo XLS');
          }
        });

      }
    })


  }

  const deleteProdutoTabloide = (row) => {  

    setLoadingProd(true);

    const url = settings.url + rotas.produtosTabloide;
    let retorno = rest.del(url + '?tabloid_id=' + (tabloide_id > 0 ? tabloide_id : idCadastrado) + '&produto_id=' + row.produto_id);
    
    retorno.then(ret => {           
      if (ret.success && ret.success == 'S') {
        listarProdutosTabloide();
      } else {
        Swal.fire(
          'Erro',
          'Erro excluindo produto!',
          'error'
        )
        setLoadingProd(false);
      }      
    })
  }

  const selecionaTodasLojas = (e) => {
    const valor = e.target.checked;
    const ljs = lojas;
    const oLojas = [];

    ljs.map(loja => {
      loja.checked = valor;
      oLojas.push(loja);
    })

    setLojas(oLojas);
  }

  const excluiTabloide = () => {
    Swal.fire({
      title: 'Tem certeza de que deseja excluir esse tablóide?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sim',
      denyButtonText: 'Não',
    }).then((result) => {
      if (result.isConfirmed) {
        const url = settings.url + rotas.deletaTabloide;
        let retorno = rest.del(url + '?tabloide_id=' + (tabloide_id > 0 ? tabloide_id : idCadastrado));

        retorno.then(ret => {
          if (ret.success) {
            setForm(initialForm);
            selecionaTodasLojas({ target: { value: false } })
            fecharModal();
          } else {
            Swal.fire(
              'Erro',
              'Erro excluindo tablóide!',
              'error'
            )
          }
        })
      }
    })
  }

  const editaPrecoProduto = (type, { data, cellEdit: { rowId, dataField, newValue } }) => {

    let preco = 0;
    let cod_barras = '';
    let prod_id = ''

    const lista = listaProdutosTabloide;

    newValue = newValue.replace(/[^0-9|.|,]/g, '');
    newValue = newValue.replace(',', '.');

    if (newValue === '') {
      setRefresh(refresh + 1)
      return
    }

    if (newValue > 0) {
      lista.map(produto => {
        if (produto.cod_barras === rowId) {

          produto.preco_tabloid = newValue

          preco = newValue.replace(',', '.');
          cod_barras = produto.cod_barras;
          prod_id = produto.produto_id;
        }
      })

      const url = settings.url + rotas.produtosTabloide;

      const parametros = {
        produto_id: prod_id,
        preco_tabloid: preco,
        tabloid_id: tabloide_id > 0 ? tabloide_id : idCadastrado
      }

      let retorno = rest.put(url, parametros);
      retorno.then(ret => {
        if (ret.success === 'S') {

          const lista = listaProdutosTabloide;

          lista.map(produto => {
            if (produto.cod_barras === rowId) {
              newValue = newValue.replace(/[^0-9|.|,]/g, '');
              newValue = newValue.replace(',', '.');

              if (newValue === '') {
                newValue = '0';
              }

              produto.preco_tabloid = newValue
            }
          })

          setListaProdutosTabloide(lista);
          setRefresh(refresh + 1);
        } else {
          Swal.fire(
            'Erro',
            'Erro gravando produto!',
            'error'
          )
        }
      })
    }
  }

  const imprimeTabloide = () => {
    let url = homepage + '/webgestor/api/tabloides/pdf';

    const parametros = {
      tabloide_id: tabloide_id
    }

    console.log(url);

    const retorno = rest.post(url + '/index.php', parametros)
    retorno.then(ret => {
      if (ret.success == 'S') {
        console.log(url + ret.path);

        const pdfWindow = window.open();

        pdfWindow.location.href = url + ret.path;
      } else {
        formSwal.fire('Erro na geração do PDF!', ret.msg, 'error')
      }
    })
    return (true)

  }

  const carregaArquivo = (file) => {
    const reader = new FileReader();

    reader.onload = () => {
      var text = reader.result;
      console.log(text);

    };

    reader.readAsText(file[0]);
  }

  const changeModalPlanilha = () =>{
    setModalPlanilha(!modalPlanilha);
  }

  // const listaLojasParticipantes = ()=>{
  //   const url = settings.url + rotas.listarLojasTabloide;                                

  //     const retorno = rest.get(url + '?tabloide_id=' + tabloide_id);
  //     //const retorno = rest.get(url);
  //     let ljs = [];
  //     retorno.then(ret => {
  //       ljs = lojas;
  //       console.log(ljs);
  //       ret.retorno.map(loja=>{
  //         for(let x = 0; x < 1;x++){
  //           if(loja.filial_id === ljs[x].filial_id){
  //             ljs[x].checked = true;
  //           }
  //         }
  //       })
  //     }) 
  //     setLojas(ljs);
  //     setRefresh(refresh+1);   
  // }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }
  return (
    <>
      <Modal key = 'modalT' size = 'lg' isOpen  = {modalPlanilha}>
        <ModalHeader>Exemplo do padrão da planilha para importação</ModalHeader>
        <ModalBody className="d-flex justify-content-center">
          <Iframe 
            url="http://webdev.digifarma.com.br/webgestor/api/tabloides/img/planilha-tabloide.png"
            width="480px"
             height="260px"
            id=""
            className=""
            display="block"
            // position="relative"
            >
          </Iframe>  
        </ModalBody>
        <ModalFooter>
                <Row>
                  <Col className="mr-2">                 
                    <Button 
                      type="button" 
                      color="danger" 
                      onClick={changeModalPlanilha}
                    >Fechar</Button>
                  </Col>
                </Row>
              </ModalFooter>
      </Modal>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Nav pills className="nav-pills-default justify-content-center mb-3">
            <NavItem>
              <NavLink
                // className = {{ active: activeTab === '1' }}
                className={activeTab == '1' ? 'active' : ''}
                onClick={() => { toggleTab('1'); }}
              >
                Identificação
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                // className = {{ active: activeTab === '2' }}
                className={activeTab == '2' ? 'active' : ''}
                onClick={() => { toggleTab('2'); }}
              >
                Produtos
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          {/* IDENTIFICACAO*/}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Form>
                <Row>
                  <Col md='3'>
                    <FormGroup>
                      <Label for="tabloide_id">Código do Tablóide</Label>
                      <Input
                        disabled
                        id="tabloide_id"
                        name="tabloide_id"
                        style={{ background: '#F9F9F9', cursor: 'default' }}
                        type="number"
                        defaultValue={tabloide_id}
                      />
                    </FormGroup>
                  </Col>
                  <Col md='9'>
                    <FormGroup>
                      <Label for="tabloide">Tablóide</Label>
                      <Input
                        id="tabloide"
                        name="tabloide"
                        defaultValue={form.tabloid}
                        onInput={inputToUpper}
                        onBlur={blurTabloide}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="tabloide_id">Inicio Promoção</Label>
                      <DateTime
                        timeFormat={false}
                        closeOnSelect={true}
                        dateFormat="DD/MM/YYYY"
                        value={form.inicio_promocao}
                        onChange={onChangeDate('inicio_promocao')}
                        onBlur={focousOutInicio}
                      >

                      </DateTime>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label for="tabloide_id">Término Promoção</Label>
                      <DateTime
                        dateFormat="DD/MM/YYYY"
                        timeFormat={false}
                        closeOnSelect={true}
                        value={form.termino_promocao}
                        onChange={onChangeDate('termino_promocao')}
                        onBlur={focousOutTermino}
                      >

                      </DateTime>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <ReactSelect
                        name="estado"
                        label="Estado"
                        placeholder="Selecione"
                        options={estados}
                        value={{ id: form.estado, title: form.estado }}
                        onChange={blurEstado}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>
                  {/* <Col>
                    <FormGroup check inline  className="pt-4">
                      <Label check>
                        <Input
                          type="checkbox"
                          onClick={setAtivo}
                          checked={tabloide.ativo === 'S' ? true : false}
                        />
                        {'Ativo'}
                        <span className="form-check-sign">
                          <span className="check"></span>
                        </span>
                      </Label>
                    </FormGroup>
                  </Col> */}
                </Row>

                <Row>
                  <Col>
                    <Card className="card-plain border lojas">
                      <CardHeader>
                        <a id="lojas">
                          LOJAS PARTICIPANTES
                          <hr />
                        </a>
                      </CardHeader>

                      <CardBody>
                        <Col>
                          <FormGroup check inline>
                            <Label check>
                              <Input
                                type="checkbox"
                                onClick={selecionaTodasLojas}
                              />
                              {'Selecionar Todas'}
                              <span className="form-check-sign">
                                <span className="check"></span>
                              </span>
                            </Label>
                          </FormGroup>
                        </Col>

                        <Col>
                          {lojas.map(
                            loja =>
                              <FormGroup check inline key={loja.filial_id}>
                                <Label check>
                                  <Input
                                    id={loja.filial_id}
                                    type="checkbox"
                                    checked={loja.checked}
                                    onChange={checkLoja}
                                  />
                                  {loja.fantasia}
                                  <span className="form-check-sign">
                                    <span className="check"></span>
                                  </span>
                                </Label>
                              </FormGroup>
                          )}
                        </Col>
                      </CardBody>

                    </Card>
                  </Col>
                </Row>
              </Form>
              <Row>
                <Col className="text-center p-3">
                  <Button
                    type="button"
                    className="mb-0 mt-0"
                    color="success"
                    size="md"
                    onClick={gravaTabloide}
                  >Salvar
                  </Button>
                  <Button
                    type="button"
                    className="mb-0 mt-0"
                    size="md"
                    color={'info'}
                    onClick={imprimeTabloide}
                  >Imprimir</Button>
                  <Button
                    type="button"
                    className="mb-0 mt-0"
                    size="md"
                    color={'danger'}
                    onClick={excluiTabloide}
                  >Excluir Tabloide</Button>
                  <Button
                    type="button"
                    className="mb-0 mt-0"
                    color="default"
                    size="md"
                    onClick={fecharModal}
                  >Fechar</Button>
                </Col>
              </Row>
            </TabPane>
          </TabContent>

          {/* PRODUTOS*/}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="2">

              <Row>
                <Col>
                  <FormGroup>
                    <AsyncSelect
                      cacheOptions
                      placeholder="Código de barras ou descrição do produto..."
                      onChange={produtoSelecionado}
                      loadOptions={pesquisaProdutos}
                    />
                    {/* <ReactSelect
                      name="produtos"
                      options={pesquisaProdutos}
                      placeholder="Código de barras ou descrição do produto..."
                    >
                    </ReactSelect> */}
                  </FormGroup>
                </Col>

                <Col md='3'>
                  <FormGroup>
                    <Input
                      id="tabloide_id"
                      name="tabloide_id"
                      type="number"
                      placeholder="Valor Promocional"
                      onChange={changeValorPromocional}
                      value={valorPromocional}
                      onKeyPress={(e) => { if (e.key === 'Enter') { adicionaProdutoTabloide() } }}
                    />
                  </FormGroup>
                </Col>

                <Col md="2" className="">
                  <Button
                    className="w-100 m-0"
                    color="info"
                    onClick={adicionaProdutoTabloide}
                  >
                    <i className="fas fa-plus" />
                    Adicionar
                  </Button>
                </Col>

                <Col md="1" hidden={true}>
                  <input
                    type="file"
                    id="localizar"
                    name="localizar" 
                    ref={inputRef}   
                    accept=".xls;.xlsx"              
                    //label={retornoXML}
                    //onChange={(change)=>console.log(change.target.value)}
                    onChange={carregaXLS}
                    //disabled={disableBtnLocalizar}
                  />
                </Col>

                <Col md="2" className="">
                  <Button
                    className="w-100 m-0"
                    color="success"
                    onClick={()=>{inputRef.current.click()}}
                  >
                    <i className="fas fa-list" />
                    XLS
                  </Button>
                </Col>

                <Col md="2" className="">
                  <Button
                    className="w-100 m-0 color-modelo"                    
                                      
                    onClick={changeModalPlanilha}
                  >
                    <i className="fas fa-list" />
                    Modelo XLS
                  </Button>
                </Col>

              </Row>

              <Row>
                
                  {loadingProd && <Col><Loading tipo='componente'></Loading></Col>}
                
                {loadingProd == false &&
                  <Col>
                    <BootstrapTable
                      striped
                      remote
                      keyField='cod_barras'
                      noDataIndication="Nenhum registro encontrado"
                      rowStyle={{ cursor: "pointer" }}
                      data={listaProdutosTabloide}
                      columns={columns}
                      cellEdit={
                        cellEditFactory({
                          mode: 'dbclick'
                        })
                      }
                      onTableChange={(type, { data, cellEdit: { rowId, dataField, newValue } }) => editaPrecoProduto(type, { data, cellEdit: { rowId, dataField, newValue } })}
                    />
                  </Col>                
                }
              </Row>

              {/* <Row>
                <Col>
                  <FormGroup style={{zIndex:0}} className="mb-0">
                    <CustomInput                
                      type="file"
                      id="localizar"
                      name="localizar"
                      label="Importar produtos através de um arquivo (XLS, XLSX)"
                      onChange={carregaXLS}
                      accept=".xls, .xlsx"
                    //enctype="multipart/form-data"
                    />
                  </FormGroup>
                </Col>
              </Row> */}

              <Row>
                <Col className="text-center p-3">
                  <Button
                    type="button"
                    className="mb-0 mt-0"
                    color="default"
                    size="md"
                    onClick={fecharModal}>Fechar</Button>
                </Col>
              </Row>

            </TabPane>
          </TabContent>
        </ModalBody>
      </FormGroup>

    </>
  )
}

export default FormCadastroTabloide;